import script from "./AdminPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPermission.vue?vue&type=script&setup=true&lang=js"

import "./AdminPermission.vue?vue&type=style&index=0&id=462c3b64&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462c3b64"]])

export default __exports__